// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  AppPlatform,
  AppType,
  DistributionMode,
} from "./types";


export default __t.row({
  appId: __t.string().primaryKey().name("app_id"),
  displayName: __t.string().name("display_name"),
  description: __t.string(),
  get platform() {
    return AppPlatform;
  },
  get appType() {
    return AppType.name("app_type");
  },
  get distributionMode() {
    return DistributionMode.name("distribution_mode");
  },
  executablePath: __t.option(__t.string()).name("executable_path"),
  createdAt: __t.timestamp().name("created_at"),
  createdBy: __t.identity().name("created_by"),
  orgId: __t.string().name("org_id"),
});
